"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationControl = void 0;

var React = _interopRequireWildcard(require("react"));

var mapboxgl = _interopRequireWildcard(require("mapbox-gl"));

var _Map = require("./Map");

var NavigationControl = function NavigationControl(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-right' : _ref$position;
  var map = React.useContext(_Map.MapContext);
  React.useEffect(function () {
    var navigation = new mapboxgl.NavigationControl();

    if (!(map === null || map === void 0 ? void 0 : map.hasControl(navigation))) {
      map === null || map === void 0 ? void 0 : map.addControl(navigation, position);
    }

    return function () {
      if (map === null || map === void 0 ? void 0 : map.hasControl(navigation)) {
        map.removeControl(navigation);
      }
    };
  }, [map, position]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

exports.NavigationControl = NavigationControl;